import styled from 'styled-components';

export const CarouselViewport = styled.div`
  /* clip the neighbouring slides at the content grid so wide viewports
     don't reveal the adjacent slides in the side margins. equal vertical
     padding and negative margin give the cards' hover lift + shadow room
     to breathe without being clipped, and keep the layout footprint intact */
  overflow: hidden;
  padding: 64px 0;
  margin-top: -64px;
  margin-bottom: -64px;
`;

export const CarouselNavigator = styled.div`
  display: flex;
  flex-direction: row;
  /* arrows flank the dots and the whole group sits centered under the carousel */
  justify-content: center;
  align-items: center;
  gap: 16px;
  /* horizontal margin tracks the carousel: 5.555vw until the content
     hits the 1216px grid, then the leftover viewport becomes margin */
  margin: 0.555vw max(5.555vw, calc((100% - 1216px) / 2)) 0;

  .dotsNavigationWrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  .prev_slide,
  .next_slide {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    border: 1.5px solid #FFFFFF;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    &.disabled {
      opacity: 0.5;
      cursor: no-drop;
    }

    svg {
      user-select: none;
      width: 16px;
      height: 16px;
    }

    &:hover {
      background: #FFFFFF;
      border: 1.5px solid #FFFFFF;
      .arrow {
        path {
          stroke: #7F7F7F;
        }
      }
    }
  }

  .prev_slide {
    padding-right: 6px;
  }

  .next_slide {
    padding-left: 2px;
  }

  @media (min-width: 992px) and (max-width: 1439px) {
    margin-top: 8px;
  }

  @media (max-width: 991px) {
    margin: 24px auto 0 auto;
    .prev_slide,
    .next_slide {
      display: none;
    }
  }
`;

export const Dot = styled.div`
  background-color: #FFF;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  opacity: ${props => props.active ? 1 : 0.5};
  @media (max-width: 991px) {
    background-color: #CBFA05;
    height: 6px;
    width: 6px;
  }
`;

export const PostCardStyled = styled.div`
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  background-size: cover;
  width: ${props => `calc(0.28889 * ${props.windowWidth}px)`};
  height: ${props => `calc(0.28889 * ${props.windowWidth}px)`};
  background-image: ${props => `url(${props.image})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition:
    transform 0.35s cubic-bezier(0.16, 1, 0.3, 1),
    border-color 0.35s ease,
    box-shadow 0.35s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(203, 250, 5, 0.45);
    box-shadow: 0 24px 56px -24px rgba(203, 250, 5, 0.28);
  }

  .postOverlay {
    width: 100%;
    height: 100%;
    background: linear-gradient(360deg, #000 0%, rgba(0, 0, 0, 0) 59.91%);
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    /* editorial byline: avatar (photo or initials) + name + role */
    .postByline {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;

      .postAvatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        object-fit: cover;
        border: 1.5px solid rgba(255, 255, 255, 0.35);
        flex-shrink: 0;
      }

      .postAvatarInitials {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: rgba(203, 250, 5, 0.16);
        border-color: rgba(203, 250, 5, 0.45);
        color: #cbfa05;
        font-family: 'Hind Madurai', sans-serif;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.5px;
      }

      .postAuthorText {
        display: flex;
        flex-direction: column;
        line-height: 1.25;
        min-width: 0;

        b {
          font-family: 'Hind Madurai', sans-serif;
          font-size: 12.5px;
          font-weight: 600;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        i {
          font-style: normal;
          font-family: 'Hind Madurai', sans-serif;
          font-size: 11px;
          color: rgba(255, 255, 255, 0.65);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .postTextWrapper {
      height: 28%;

      .postTitle {
        font-weight: 500;
        line-height: min(2.29vw, 31px);
        letter-spacing: 0em;
        text-align: left;
        color: #fff;
        font-family: 'Hind Madurai', sans-serif;
        font-size: min(1.666vw, 23px);
        margin-bottom: 8px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;


        @media (max-width: 576px) {
          font-size: 4.61vw;
          line-height: 6.369vw;
        }
      }
    }

    .postLinkWrapper {
      display: flex;
      align-items: center;

      .postLink {
        font-size: min(0.83vw, 11.5px);
        line-height: min(1.11vw, 15.5px);
        letter-spacing: 0.05em;
        font-weight: 500;
        margin-right: 6px;
        color: #CBFA05;
        text-decoration: none;
        font-family: 'Hind Madurai', sans-serif;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        max-height: 3.6em;

        @media (max-width: 576px) {
          font-size: 3.07vw;
          line-height: 4.102vw;
        }
      }
      
      .arrowLeft {
        font-size: min(0.83vw, 11.5px);
        line-height: min(0.69vw, 9.5px);

        @media (max-width: 576px) {
          width: 3.07vw;
          height: 2.56vw;
        }
      }
    }
  }

  /* "publicado em" badge pinned to the card's top-right corner */
  .postOutletBadge {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 70%;
    padding: 6px 12px;
    border-radius: 100px;
    background: rgba(2, 3, 10, 0.62);
    border: 1px solid rgba(255, 255, 255, 0.16);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    img {
      height: 16px;
      max-width: 88px;
      object-fit: contain;
      display: block;
    }

    span {
      font-family: 'Hind Madurai', sans-serif;
      font-size: 10.5px;
      font-weight: 600;
      letter-spacing: 1.1px;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.85);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .sr-only-name {
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      white-space: nowrap;
    }
  }

  @media (max-width: 576px) {
    height: 87.7vw !important;
    width: 100%;
  }
`;

export const PostBlocWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
`;